import { apiPath } from '../../constants';
import { axios, apiRequestOptions, errorRequestHandler, transformHttpResponse } from 'utils';

export const SCHEDULE_FETCH_REQUEST = 'SCHEDULE_FETCH_REQUEST';
export const SCHEDULE_FETCH_SUCCESS = 'SCHEDULE_FETCH_SUCCESS';
export const SCHEDULE_FETCH_FAILURE = 'SCHEDULE_FETCH_FAILURE';

export const fetchSchedule = (competitionId) => {
  return function (dispatch) {
    dispatch({ type: SCHEDULE_FETCH_REQUEST });
    return axios(apiRequestOptions(apiPath.SCHEDULE.GET, null, { params: { id: competitionId } }))
      .then(transformHttpResponse)
      .then(response => dispatch({ type: SCHEDULE_FETCH_SUCCESS, data: response.data }))
      .catch(error => transformHttpResponse(error.response))
      .catch(error => {
        dispatch({ type: SCHEDULE_FETCH_FAILURE, error });
        dispatch(errorRequestHandler(error));
      });
  };
};
